jQuery(document).ready(function(){
    jQuery('.column-card:not(.popout):not(.iframe) .img-container button[aria-label="play video"]').click(function(){
        video_column_controller.init(jQuery(this).closest('.column-card .img-container')[0]);
    });
    jQuery('.column-card.popout:not(.iframe) button').click(function(){
        video_column_controller.popout_init(jQuery(this).closest('.column-card .img-container')[0]);
    });
    jQuery('.column-card.iframe.inline .img-container button[aria-label="play video"]').click(function(){
        video_column_controller.iframe_inline_init(jQuery(this).closest('.column-card .img-container')[0]);
    });
    jQuery('.column-card.iframe.popout .img-container button[aria-label="play video"]').click(function(){
        video_column_controller.iframe_popout_init(jQuery(this).closest('.column-card .img-container')[0]);
    });
    jQuery('.column-card.inline-auto-play .img-container button[aria-label="play video"]').trigger('click');
});